import { Link } from 'react-router-dom';
import ScrollReveal from '@/components/ScrollReveal';
import { SERVICES, getStartingPrice, formatPrice } from '@/lib/pricing';
import { ArrowRight } from 'lucide-react';

export default function CampaignServices() {
  return (
    <section className="py-16 md:py-32 bg-secondary/30">
      <div className="max-w-[1600px] mx-auto px-6 md:px-10 lg:px-16">
        <ScrollReveal>
          <div className="text-center max-w-2xl mx-auto mb-16">
            <p className="caps-label text-orange mb-4">Bundle & Save</p>
            <h2 className="font-display font-extrabold text-navy" style={{ fontSize: 'clamp(2rem, 4vw, 3rem)' }}>
              Every service your property needs
            </h2>
            <p className="text-lg text-muted-foreground mt-4">
              Book two or more services together and get <span className="text-orange font-semibold">10% off</span> your inventory reports.
            </p>
          </div>
        </ScrollReveal>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {SERVICES.map((service, i) => (
            <ScrollReveal key={service.id} delay={i * 0.05}>
              <Link to="/request-quote" className="group block bg-background rounded-2xl p-6 hover:shadow-lg transition-shadow h-full">
                <div className="flex items-start justify-between mb-4">
                  <span className="caps-label text-muted-foreground">{service.short}</span>
                  <ArrowRight className="text-muted-foreground group-hover:text-orange transition-colors" size={18} />
                </div>
                <h3 className="font-semibold text-navy mb-2 leading-snug">{service.name}</h3>
                <p className="text-sm text-muted-foreground mb-4 line-clamp-2">{service.description}</p>
                <p className="text-sm text-muted-foreground">From <span className="font-semibold text-navy">{formatPrice(getStartingPrice(service.id))}</span></p>
              </Link>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
}